/**
 * Extracts all tickers from a portfolio series
 * @param portfolioSeries {Array[Object]} Array of objects containing 'snapshot' object
 * @returns {*}
 */
export const getAllTickersFromSnapshots = (portfolioSeries) => {
    const snapshots = portfolioSeries.map(x => x.snapshot);
    return snapshots.reduce((acc, snapshot) => {
        Object.keys(snapshot).forEach(key => {
            if (!acc.includes(key)) {
                acc.push(key);
            }
        });
        return acc;
    }, []);
}